(() => {
  const row = document.getElementById('gAAQhtsVqK');
  const banner = row?.closest('section');
  if (!banner) return;

  let previousHeight;
  const updateSpacing = () => {
    const height = getComputedStyle(banner).position === 'fixed'
      ? Math.ceil(banner.getBoundingClientRect().height)
      : 0;
    if (height === previousHeight) return;
    previousHeight = height;
    document.body.style.setProperty('--klofix-promo-height', `${height}px`);
  };

  // GemPages loads its styles lazily; observe both hydration and later wrapping.
  new ResizeObserver(updateSpacing).observe(banner);
  window.addEventListener('resize', updateSpacing, { passive: true });
  window.addEventListener('load', updateSpacing, { once: true });
  updateSpacing();
})();
